/**
 * Nom recopié pour signer (21/10/2026) : ni les majuscules, ni les accents, ni les espaces en trop, ni les
 * apostrophes (’ ou '), ni les tirets ne comptent. Même règle que le serveur
 * (backend/src/modules/contract-signatures/signer-name.ts) : corriger les deux à la fois.
 */
export function signerNameKey(value: string): string {
  return value
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .replace(/œ/g, 'oe')
    .replace(/æ/g, 'ae')
    .replace(/[’‘`´'.]/g, '')
    .replace(/[-‐‑–—_]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Vrai si le texte tapé est le nom attendu, à la forme près. */
export function sameSignerName(typed: string, expected: string): boolean {
  const key = signerNameKey(typed);
  return key.length > 0 && key === signerNameKey(expected);
}
